var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('auth-sidebar'),_c('notebook-sidebar'),_c('ts-profile-panel'),_c('worker-sidebar-new'),_c('company-sidebar'),_c('ts-job-panel'),_c('cookie-banner'),_c('ModalCourses'),_c('ts-course-panel')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }